if (!customElements.get('code-cart-item-form')) {
  customElements.define(
    'code-cart-item-form',
    class CodeCartItemForm extends HTMLElement {
      connectedCallback() {
        const form = this.firstElementChild;
        const sections = [this.closest('code-cart-form').getAttribute('data-section-id'), 'main-product'];

        /** @param {Event} e */
        const update = async (e) => {
          const currentValue = e.target.value;
          const previousValue = e.target.defaultValue;

          const direction = currentValue - previousValue;

          const groupQuantity =
            parseInt(this.closest('cart-drawer-group').getAttribute('data-group-quantity')) + direction;

          this.closest('code-cart-item').toggleAttribute('data-loading', true);
          this.closest('code-cart-form').toggleAttribute('data-loading', true);

          const cartGroup = this.closest('cart-drawer-group');
          const totalBoxes = cartGroup.querySelectorAll('shipping-box').length;
          let filledBoxes = groupQuantity % totalBoxes;

          if (groupQuantity == 0) {
            filledBoxes = 0;
          } else {
            if (groupQuantity % totalBoxes == 0) {
              filledBoxes = totalBoxes;
            }
          }
          cartGroup.toggleAttribute('data-active', totalBoxes == filledBoxes);

          cartGroup.querySelectorAll('shipping-box').forEach((box, index) => {
            if (index < filledBoxes) {
              box.toggleAttribute('data-fill', true);
            } else {
              box.toggleAttribute('data-empty', true);
            }
          });

          const cart = await fetch(routes.cart_change_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              line: e.target.dataset.index,
              quantity: e.target.value,
              sections,
              sections_url: window.location.pathname,
            }),
          }).then((r) => r.json());

          if (cart.errors)
            cart.sections = await fetch(`${window.location.pathname}?${new URLSearchParams({ sections })}`).then((r) =>
              r.json(),
            );

          await fetch(routes.cart_url, {
            method: 'GET',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/json',
            },
          })
            .then((r) => r.json())
            .then((r) => {
              publish('cartUpdate', { ...r, sections: cart.sections, direction });
            });
        };

        const debouncedUpdate = debounce(update, 300);

        form.addEventListener('change', (e) => {
          const input = form.querySelector('input');
          if (e.target.value === '0') {
            update(e); // immediately remove
          } else {
            if (parseInt(input.getAttribute('max')) < parseInt(e.target.value)) return;
            debouncedUpdate(e);
          }
        });
      }
    },
  );
}
